module.exports = __webpack_public_path__ + "static/media/03-Dr-Sayang.4ce5b8c3.png";